package com.milta.core.localization.translations.bg

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Зареждане…",
    errorNoConnection = "Сървърът не може да бъде достигнат — провери връзката си.",
    errorGeneric = "Възникна грешка. Опитай отново по-късно.",
    readOnlyNotice = "🔒 Само преглед — от този екран все още не може да се създава, редактира или спира акаунт.",
    kpiAccountsLabel = "Акаунти",
    kpiAccountsSubtitle = "всички роли общо",
    kpiDriversLabel = "Шофьори",
    kpiDriversSubtitle = "без собствен екип",
    kpiPatronsLabel = "Собственици",
    kpiPatronsOrgSingular = "организация",
    kpiPatronsOrgPlural = "организации",
    kpiActiveSubsLabel = "Активни абонаменти",
    kpiActiveSubsSubtitle = "активен + гратисен период",
    kpiAtRiskLabel = "Застрашени",
    kpiAtRiskSubtitle = "пробен период или изтекъл",
    searchPlaceholder = "Търси по име, имейл, организация…",
    expandAllAction = "Разгъни всички",
    collapseAllAction = "Свий всички",
    columnAccount = "Акаунт",
    columnContact = "Контакт",
    columnType = "Тип",
    columnAddedDate = "Добавен / създадена на",
    columnSubscription = "Абонамент",
    columnSince = "От",
    columnRenewal = "Подн.",
    noOrganizationHeader = "Без организация",
    emptySearchResult = "Няма акаунт, отговарящ на това търсене.",
    patronBadgePrefix = "Собственик",
    createdOnPrefix = "Създадена на",
    emptyTeamMessage = "Все още няма шофьор в този екип.",
    driverBadge = "Шофьор",
    addedOnPrefix = "Добавен на",
    viaOrganization = "Чрез организация",
    accountCreatedOnUnknown = "Акаунт създаден на —",
    renewalSingular = "подновяване",
    renewalPlural = "подновявания",
    subscriptionNone = "Няма",
    subscriptionActive = "Активен",
    subscriptionTrial = "Пробен",
    subscriptionGrace = "Гратисен",
    subscriptionExpiredStatus = "Изтекъл",
    subscriptionCancelled = "Отказан",
    planOrganization = "Организация",
    planDriver = "Шофьор",
)
